<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-links">
        <div>
          <a href="http://hrczh.cass.cn/" target="_blank" class="footer-link">中国历史研究网</a>
          <a href="http://www.cssn.cn/" target="_blank" class="footer-link">中国社会科学网</a>
          <a href="http://www.lib.cass.org.cn/" target="_blank" class="footer-link">中国社会科学院图书馆</a>
        </div>
        <div>
          <a href="https://dl.ndl.go.jp/" target="_blank" class="footer-link">日本国立国会图书馆</a>
          <a href="http://www.nssd.cn/" target="_blank" class="footer-link">国家哲学社会科学学术期刊数据库</a>
          <a href="http://www.modernhistory.org.cn/index.htm" target="_blank" class="footer-link">抗日战争与近代中日关系数据库</a>
        </div>
        <div>
          <a href="https://www.jacar.go.jp/" target="_blank" class="footer-link">亚洲历史资料中心</a>
          <a href="http://www.hist.pku.edu.cn" target="_blank" class="footer-link">北京大学历史学系</a>
          <a href="http://cqkzhf.swu.edu.cn" target="_blank" class="footer-link">重庆中国抗战大后方研究中心</a>
        </div>
        <div>
          <a href="http://www.historychina.net/" target="_blank" class="footer-link">中华文史网</a>
          <a href="https://toyo-bunko.or.jp/" target="_blank" class="footer-link">东洋文库</a>
          <a href="http://mhdb.mh.sinica.edu.tw/" target="_blank" class="footer-link">近代史数位资料库</a>
        </div>
      </div>
      <div class="footer-info">
        <p>版权所有 © 2025 西南大学中国抗战大后方研究中心 |
          <img src="../assets/police_logo.png" width="16" height="17"/>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=50024202000314" rel="noreferrer" target="_blank">渝公网安备50024202000314号</a> |
          <a href="https://beian.miit.gov.cn" target="_blank">渝ICP备2025065616号-1</a></p>
        <br>
        <p>推荐使用Chrome浏览器访问本网站</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: var(--primary-dark);
  color: var(--white);
  padding: 30px 0;
  margin-top: 40px;
}

.footer-container {
  width: min(1200px, 96%);
  margin: 0 auto;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.footer-link {
  color: var(--white);
  text-decoration: none;
  transition: var(--transition);
  display: block;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.footer-link:hover {
  color: var(--primary-light);
  text-decoration: underline;
}

.footer-info {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
}

.footer-info a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
}

.footer-info img,
.footer-info a,
.footer-info p {
  display: inline-block;
  vertical-align: middle;
  line-height: 1; /* 可选，调整行高以匹配 */
}

.footer-info a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .footer-links {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}
</style>